import React, { Suspense } from "react";
import { CircularProgress, Box } from "@mui/material";

const LazyLoader = ({ children }) => (
	<Suspense
		fallback={
			<Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
				<CircularProgress />
			</Box>
		}
	>
		{children}
	</Suspense>
);

export default LazyLoader;
